import Helper from "./helper";

/**
 *
 * This function checks locationData response for commissionJunctionRules configuration.
 * for all products have boolean property aside from campaigns which have arrays of business category id to check
 *
 *
 * @param {object} locationData = response from locationData API that will be used to extract the object of `commisionRuleJunction`
 * @param {string} [paymentType] = optional parameter that is used, currently, to track `payWithPoints`. In relation to the commissionJunctionRule
 *
 */

export const commissionJunctionRules = (locationData, paymentType) => {
  const commissionJunction = locationData?.commissionJunctionRules || {};
  const salesTypeId = localStorage.getItem("salesTypeId") || [];

  if (!locationData || !Object.keys(commissionJunction).length) {
    return;
  }

  const currentQueryLocation = new URLSearchParams(window.location?.search);
  const businessCategoryId = currentQueryLocation.get("bc");
  const teltomId = currentQueryLocation.get("apHotelEmployeeId");
  const expressCheckoutId = window.location.pathname
    .toLowerCase()
    .includes("express-checkout");
  const renewalId = window.location.pathname.toLowerCase().includes("renewals");
  const paymentTypeSanitize = paymentType?.replace(/ /g, "").toLowerCase();
  /**
   * @params {boolean} - Use for appending #cj fragment to url to track commissionable items
   */
  let appendCJRule = true;

  for (let commission in commissionJunction) {
    switch (commission) {
      case "partnerships":
        if (salesTypeId === "1") {
          appendCJRule = commissionJunction.partnerships;
        }
        break;

      case "payWithPoints":
        if (paymentTypeSanitize === "paywithpoints") {
          appendCJRule = commissionJunction.payWithPoints;
        }
        break;

      case "hotelSales":
        if (Helper.hotelDetected())
          appendCJRule = commissionJunction.hotelSales;
        break;

      case "campaigns":
        if (commissionJunction.campaigns.includes(parseInt(businessCategoryId)))
          appendCJRule = !commissionJunction.campaigns.length;
        break;

      case "telTOM":
        if (teltomId) appendCJRule = commissionJunction.telTOM;
        break;

      case "renewal":
        if (expressCheckoutId || renewalId)
          appendCJRule = commissionJunction.renewal;
        break;

      default:
        appendCJRule = true;
    }
  }
  console.log(appendCJRule, "cjFinal");
  return appendCJRule ? "#cj" : "";
};
